// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"551debdf","270":"ca2d803d","383":"5f584952","412":"a5a4fecd","730":"59c5e5b4"}[chunkId] + ".chunk.css";
};